let prefix = '/api/equipmentCatalog';

function getEquipmentGeneral() {
    return window.axios.get(prefix);
}

function store(data) {
    return window.axios.post(prefix,data);
}
function updateEqupmentCatalog(id, data) {
    return window.axios.patch(prefix + '/' + id, data);
}

export default {
    getEquipmentGeneral,store, updateEqupmentCatalog
    
}